import { cn } from '@/utils/classname';
import { SVGProps } from 'react';
import { fakeStroke, fill } from './classNames';

export const TemplatesIcon = ({
  isActive,
  className,
  ...props
}: { isActive: boolean } & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 18 20"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={cn('group', className)}
    >
      <rect
        className={fill(isActive)}
        height="18.32"
        rx="1.16"
        strokeWidth="1.68"
        width="16.32"
        x="0.84"
        y="0.84"
      />
      <rect className={fakeStroke(isActive)} height="1.68" rx="0.84" width="10" x="4" y="4" />
      <rect className={fakeStroke(isActive)} height="1.68" rx="0.84" width="10" x="4" y="9" />
      <rect className={fakeStroke(isActive)} height="1.68" rx="0.84" width="10" x="4" y="14" />
    </svg>
  );
};
